// Copyright (c) Docugami, Inc. All rights reserved.

const { v4: uuidv4 } = require('uuid');

export class RefCount {
    private readonly _onCreate: () => void;
    private readonly _onDestroy: () => void;
    private readonly _refSet: Set<string> = new Set();
    get refCount(): number { return this._refSet.size; }

    constructor(
        create?: () => void,
        destroy?: () => void) {
        this._onCreate = create ?? (() => {});
        this._onDestroy = destroy ?? (() => {});
    }

    acquire(): () => void {
        const id = uuidv4();
        this._refSet.add(id);

        if (this.refCount === 1) {
            this._onCreate();
        }

        return () => this.release(id);
    }

    private release(id: string) {
        this._refSet.delete(id);
        if (this.refCount === 0) {
            this._onDestroy();
        }
    }
}
